export function LivestockModel (livestock) {
    this.name = livestock.name;
    this.nameEN = livestock.nameEN;
    this.value = livestock.value;
    this.breeds = [];

    livestock.breeds.forEach(breed => {
        var newBreed = new BreedModel(breed.name, breed.nameEN, breed.value, breed.amount);
        this.breeds.push(newBreed);
    });

    return this;
}

export function BreedModel (name, nameEN, value, amount) {
    this.name = name || "";
    this.nameEN = nameEN || "";
    this.value = value || "";
    var tmpAmount = amount.toString();
    this.amount = tmpAmount.replace(',', '') || 0;
}

export function OtherBreedModel () {
    this.name = "";
    this.nameEN = "";
    this.value = "";
    this.amount = "";
}
